import React, { useLayoutEffect, useState } from "react";
import CustomButton from "./CustomButton";
// import { INSTAGRAM_APP_LINK, INSTAGRAM_LINK } from "../constants/constants";
import { Link } from "react-router-dom";
import { database, ref, get } from "../firebase";
// import { isMobileUserAgent } from "../helpers/helpers";
import Image from "./Image";
import { scrollToElement } from "../helpers/helpers";

function Main({
    path,
    buttonClassNames = "",
    borderStyles = "border-custom-yellow",
    firstTitleLine = "Унікальна коллекція від",
    secondTitleLine = "Харківської Ювелірної Фабрики",
    logoClassNames = "",
    textColor = "text-white",
    logoImage,
    defaultImage,
    logoAlt,
}) {
    const [mainImages, setMainImages] = useState([]);
    const firstImage = mainImages?.[0];
    const secondImage = mainImages?.[1];

    useLayoutEffect(() => {
        const dbRef = ref(database, `/${path}/mainImages`);

        get(dbRef)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    setMainImages(snapshot.val().items);
                } else {
                    console.log("No data available");
                }
            })
            .catch((error) => {
                console.error(error);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={`px-6 xl:px-0 border-b-8 ${borderStyles}`}>
            <div className="flex justify-evenly items-center flex-col lg:flex-row">
                <div className="hidden lg:flex items-center justify-center mr-0 w-full lg:w-1/3">
                    <Image
                        className={`h-auto w-auto`}
                        highQualitySrc={firstImage?.image}
                        lowQualitySrc={defaultImage}
                        alt="FirstImage"
                    />
                </div>

                <div
                    className={`flex items-center justify-center flex-col ${textColor} mb-0 lg:mb-12 w-full lg:w-1/3`}
                >
                    <div className="lighthause-font text-[50px] lg:text-6xl xl:text-[70px] mb-2.5 lg:mb-6 xl:mt-0">
                        КОЛЕКЦІЯ
                    </div>

                    <img
                        className={`h-auto px-6 xl:h-[400px] ${logoClassNames}`}
                        src={logoImage}
                        alt={logoAlt}
                        loading="eager"
                        decoding="async"
                    />

                    <div className="mt-2.5 lg:mt-6 text-lg lg:text-2xl text-center flex flex-col">
                        <span>{firstTitleLine}</span>
                        <span>{secondTitleLine}</span>
                    </div>
                </div>

                <div className="flex items-center justify-center mr-0 w-full lg:w-1/3 my-6">
                    <Image
                        className={`h-auto w-auto`}
                        highQualitySrc={secondImage?.image}
                        lowQualitySrc={defaultImage}
                        alt="SecondImage"
                    />
                </div>
            </div>

            <div className="flex lg:hidden flex-col mb-5 gap-5">
                <Link
                    onClick={() => scrollToElement("flagmans")}
                    className="mx-4 lg:mx-16"
                >
                    <CustomButton
                        title={"Флагмани колекції"}
                        className={`border-2 w-full text-lg lg:text-[22px] ${buttonClassNames}`}
                    />
                </Link>
                <Link to="/" className="mx-4 lg:mx-16">
                    <CustomButton
                        title={"Інші колекції"}
                        className={`border-2 w-full text-lg lg:text-[22px] ${buttonClassNames}`}
                    />
                </Link>
            </div>
        </div>
    );
}

export default Main;
